// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__11BZp","detailsBorder":"styles_detailsBorder__1CnlZ"};